import { SiteTaskPage } from './SiteTask';
import { createHandle } from './handle';
import { createLoader } from './loader';

export default {
  Component: SiteTaskPage,
  createHandle,
  createLoader
};
